export default __webpack_public_path__ + "static/media/stripe_logo.d707f012.png";